import { Injectable } from "@angular/core";
import { GungNavbarService, GungShopMenu } from "gung-standard";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SjoborgNavbarService extends GungNavbarService {
  assortmentMenuLevel = 3;
  showNavbarSearch: boolean = false;

  getShopMenu(isMobile?: boolean): Observable<GungShopMenu[]> {
    return super.getShopMenu().pipe(
      map(menu => {
        if (!isMobile) {
          menu = [
            ...menu,
            { link: '/quick-products', heading: this.translateService.instant('QUICK_SEARCH') },
            { link: '/news', heading: this.translateService.instant('NEWS') },
            {
              heading: 'CATALOG_ASSORTMENT',
              link: '/articles/s482'
            },
            {
              heading: this.translateService.instant('CUTTING_CALCULATOR'),
              action: () => {
                window.open('https://sjoborgs.se/skardatakaltylator/', '_blank');
              }
            },
            {
              heading: this.translateService.instant('MEASUREMENT_CALCULATOR'),
              action: () => {
                window.open('https://sjoborgs.se/matprotokoll/', '_blank');
              }
            },
            {
              heading: this.translateService.instant('CONTACT'),
              action: () => {
                window.open('https://sjoborgs.se/kontakt/', '_blank');
              }
            }
          ]
        } else {
          menu[0].links = [
            ...menu[0].links,
            { link: '/quick-products', heading: this.translateService.instant('QUICK_SEARCH') },
            { link: '/news', heading: this.translateService.instant('NEWS') },
            {
              heading: this.translateService.instant('CUTTING_CALCULATOR'),
              action: () => {
                window.open('https://sjoborgs.se/skardatakaltylator/', '_blank');
              }
            },
            {
              heading: this.translateService.instant('MEASUREMENT_CALCULATOR'),
              action: () => {
                window.open('https://sjoborgs.se/matprotokoll/', '_blank');
              }
            },
            {
              heading: this.translateService.instant('CONTACT'),
              action: () => {
                window.open('https://sjoborgs.se/kontakt/', '_blank');
              }
            }
          ]
        }
        return menu;
      })
    );
  }
}
